// extracted by mini-css-extract-plugin
export default {"link":"Header_link__qAkBV","icon":"Header_icon__a8FkJ","logo":"Header_logo__shVBB"};